import { createContext, useEffect, useState } from "react";
import api from "../api/axios";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  // user contient toutes les infos de /api/me/ :
  // - id, username, email, first_name, last_name, etc.
  // - is_admin (boolean)
  // - groups (array d'objets {id, name})
  // - permissions (array de strings)
  const [user, setUser] = useState(null);
  const [isloading, setLoading] = useState(true);

  // Fonction pour mettre à jour l'en-tête Authorization d'Axios
    const setAuthHeader = (token) => {
        if (token) {
            // Configure l'en-tête pour les requêtes futures
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        } else {
            // Retire l'en-tête si aucun token n'est fourni (déconnexion)
            delete api.defaults.headers.common['Authorization'];
        }
    };

    useEffect(() => {
        const token = localStorage.getItem('token'); // <--- ESSAYER DE RÉCUPÉRER LE JETON

        if (token) {
            // 1. Configurer Axios AVANT l'appel /api/me/
            setAuthHeader(token);
          const fetchUser = async () => {
                try {
                    // 2. Tenter de valider la session
                    const res = await api.get("/api/me/");
                    console.log("Réponse /api/me :", res.data);
                    setUser(res.data);
                } catch (err) {
                    // 3. Si le token est invalide/expiré (401), nettoyer la session
                    console.error("Token invalide ou expiré, session réinitialisée.", err);
                    localStorage.removeItem('token');
                    setAuthHeader(null); 
                    setUser(null);
                } finally {
                    setLoading(false);
                }
            };
            fetchUser();
            
        } else {
            // Si aucun token n'est trouvé, passer directement à l'état non chargé.
            setUser(null);
            setLoading(false);
        }
    }, []); 

     // --- Fonction de Connexion (à intégrer au contexte) ---
    const login = async (token) => {
        localStorage.setItem('token', token);
        setAuthHeader(token);
        
        // Relancer l'appel pour récupérer les infos utilisateur
        try {
            const res = await api.get("/api/me/");
            setUser(res.data);
            return res.data;
        } catch (error) {
            console.error("Erreur post-login lors de la récupération des infos utilisateur:", error);
            // Gérer l'erreur si /api/me/ échoue même avec un token supposé valide
            return null;
        }
    };

    // --- Fonction de Déconnexion (à intégrer au contexte) ---
    const logout = () => {
        // Clear all known token keys used in the app
        localStorage.removeItem('token');
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        setAuthHeader(null);
        setUser(null);
    };




  return (
    <UserContext.Provider value={{ user, setUser, isloading, login, logout }}>
      {children}
    </UserContext.Provider>
  );
};
